import { useEffect } from 'react';
import { pick } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

import * as pas from '../pas';

export const usePas = () => {
    const {
        ssoPasDomain, casinoName, clientType, clientSkin,
        ssoPasJsURLs, ssoPasExternalJsUrl
    } = useAppSelector(pick([
        'ssoPasDomain', 'casinoName', 'clientType', 'clientSkin',
        'ssoPasJsURLs', 'ssoPasExternalJsUrl'
    ]));

    useEffect(() => {
        if (!ssoPasDomain || !casinoName) {
            return;
        }

        pas.init({
            ssoPasDomain, casinoName, clientType, clientSkin,
            ssoPasJsURLs, ssoPasExternalJsUrl
        });
    }, [
        ssoPasDomain, casinoName, clientType, clientSkin,
        ssoPasJsURLs, ssoPasExternalJsUrl
    ]);
};
